import { PrescriptionSolutionCheck } from "../../models/pharmacy/prescription-solution-check.model";

export class PrescriptionSolutionCheckStruct {
    prescriptionSolutionCheck: PrescriptionSolutionCheck = new PrescriptionSolutionCheck();

    prescriptionStatus: number;

    userName: string;
    professionName: string;
    public prescriptionObservationOnBed: string;
    
    public isBeforeActualSchedulingCycle: boolean;
}